<!-- KwYearChart.vue -->
<template>
  <v-card class="pa-4">
    <v-card-title class="headline">
      {{ title }}
    </v-card-title>
    <v-card-text>
      <apexchart
          type="bar"
          height="360"
          :options="options"
          :series="series"
      />


    </v-card-text>

  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'KwYearChart',
  components: { apexchart: VueApexCharts },
  props: {
    title: { type: String, default: 'Jahresübersicht Schrott' },
    // 52 (oder 53) Werte – je Kalenderwoche ein Wert
    values: { type: Array, required: true },
    // Grenzwert für Linie + rote Balken darüber
    threshold: { type: Number, default: null },
    // Anzeige im Titel
    year: { type: Number, default: new Date().getFullYear() },
    // Y-Achsentitel
    yTitle: { type: String, default: 'Wert' }
  },
  computed: {
    // 1..n – wir blenden die Achsenlabels zwar aus, nutzen die Nummer im Tooltip
    labels () {
      return Array.from({ length: this.values.length }, (_, i) => `${i + 1}`)
    },
    series () {
      return [{ name: 'Wert', data: this.values }]
    },
    options () {
      const baseColor = '#1E88E5'   // Standard (unter Grenzwert)
      const dangerColor = '#E53935' // Rot (über Grenzwert)

      // Annotation für die Grenzwert-Linie
      const ann = this.threshold != null ? {
        yaxis: [{
          y: this.threshold,
          borderColor: dangerColor,
          strokeDashArray: 6,
          label: {
            text: `Grenzwert: ${this.threshold}`,
            borderColor: dangerColor,
            style: { color: '#fff', background: dangerColor }
          }
        }]
      } : {}

      // Balken-Optionen inkl. Farb-Range über Grenzwert
      const plotOptions = {
        bar: {
          borderRadius: 4,
          columnWidth: '80%'
        }
      }
      if (this.threshold != null) {
        plotOptions.bar.colors = {
          ranges: [
            // >= Grenzwert in Rot; für strikt ">" nimm: from: this.threshold + 1e-9
            { from: this.threshold, to: Number.MAX_VALUE, color: dangerColor }
          ]
        }
      }

      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          animations: { enabled: true }
        },
        colors: [baseColor],     // Basisfarbe für Balken unter Grenzwert
        plotOptions,
        dataLabels: { enabled: false },
        grid: { strokeDashArray: 4 },

        // X-Achsenlabels komplett ausblenden (Legende unten)
        xaxis: {
          categories: this.labels,   // ["1","2",...]
          labels: { show: false },
          axisTicks: { show: false },
          axisBorder: { show: false },
          tooltip: { enabled: false } // Tooltip für x regeln wir unten zentral
        },

        // Y-Achse mit Titel
        yaxis: { title: { text: this.yTitle } },

        // Tooltip zeigt "KW XX" + Wert
        tooltip: {
          x: { formatter: (val) => `KW ${val}` },
          y: { formatter: (v) => `${v}` }
        },

        // Serien-Legende aus (einzige Serie)
        legend: { show: false },

        // Grenzwert-Linie
        annotations: ann
      }
    }
  }
}
</script>
